<template>
  <div
    class="animate__bounceIn animate__animated voice-call horizontal layout center center-justified"
    :class="{
      'during-video-call': $store.state.voiceCall.status === 'during-call' && isOpenVideo === true,
      'during-audio-call': $store.state.voiceCall.status === 'during-call' && isOpenVideo === false
    }"
  >
    <div class="beta-label">
      Beta
    </div>
    <div
      v-if="$store.state.voiceCall.status === 'start-call' ||
        $store.state.voiceCall.status === 'during-call'"
      class="text-center avatar"
    >
      <aha-avatar
        :name="$store.state.voiceCall.audienceName"
        :width="160"
        :height="160"
      />
      <div class="call-status" v-if="$store.state.voiceCall.status !== 'during-call'">
        {{ $t('Dialing…') }}
      </div>
      <div class="call-status time-call" v-if="$store.state.voiceCall.status === 'during-call'">
        {{ time | convertHMS }}
      </div>
      <div class="mt-4 horizontal layout center">
        <div class="close-call" @click="closeStream()">
          <i class="fas fa-phone"></i>
        </div>
        <div class="audience-name">
          {{ $store.state.voiceCall.audienceName }}
        </div>
      </div>
    </div>
    <div v-if="$store.state.voiceCall.status === 'during-call'" :class="{'full-h': isOpenVideo}">
      <video id="remote-video"></video>
    </div>
    <video id="local-video"></video>
    <audio src="https://s3.amazonaws.com/public.ahaslide.com/static/ring-call/ring-call.mp3" id="play-call" loop></audio>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config'
import EventBus from '@/eventBus'
import utils from '@/util'

export default {
  components: {
  },
  data() {
    return {
      remoteVideo: null,
      localVideo: null,
      runTime: null,
      time: 0,
      isOpenVideo: null,
    }
  },
  computed: {
    ...mapState({
      voiceCall: (state) => state.voiceCall,
      currentUser: (state) => state.currentUser,
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
    }),
  },
  mounted() {
    this._initOpenTokSession()
    EventBus.$on('stop-video-call', () => {
      this.closeStream()
    })
  },
  destroyed() {
    EventBus.$off('stop-video-call')
    if (this.runTime) {
      clearInterval(this.runTime)
    }
  },
  methods: {
    _initOpenTokSession() {
      this.session = window.OT.initSession(config.openTokKey, this.presentation.session)
      const self = this
      // Subscribe to a newly created stream

      document.getElementById('play-call').play()

      // Create a publisher
      const publisher = window.OT.initPublisher('publisher', {
        insertDefaultUI: false,
        name: this.currentUser.id,
        publishAudio: false,
        publishVideo: false,
      }, (error) => {
        if (error) return self.handleError

        const event = {
          id: self.currentUser.id,
          stream: publisher._.webRtcStream(),
          type: 'local',
        }
        this.localVideo = event
        const localVideo = document.getElementById('local-video')
        localVideo.volume = 0
        try {
          localVideo.setAttributeNode(document.createAttribute('muted'))
        } catch (e) {
          localVideo.setAttribute('muted', true)
        }
        localVideo.srcObject = publisher._.webRtcStream()
        localVideo.play()
      })

      // Connect to the session
      self.session.connect(self.presentation.token, (error) => {
        // If the connection is successful, publish to the session
        if (error) {
          self.handleError(error)
        } else {
          self.session.publish(publisher, self.handleError)
        }
      })

      self.session.on('streamCreated', (event) => {
        const subscriber = self.session.subscribe(event.stream, {
          insertDefaultUI: false,
        }, (error) => {
          if (error) return self.handleError
          this.$store.state.voiceCall.status = 'during-call'
          const eventRemote = {
            id: subscriber.stream.name,
            stream: subscriber._.webRtcStream(),
            type: 'remote',
          }
          this.remoteVideo = eventRemote
          setTimeout(() => {
            if (this.runTime) {
              clearInterval(this.runTime)
            }
            this.runTime = setInterval(() => {
              this.time++
            }, 1000)
            const remoteVideo = document.getElementById('remote-video')
            remoteVideo.srcObject = subscriber._.webRtcStream()
            remoteVideo.play()
            this.isOpenVideo = subscriber.stream.hasVideo
            const { type, slideType } = this.slideActive
            const slideName = utils.getCorrectSlideTypeName(type, slideType)
            utils.mixpanelTracking('Video Call', 'Presenter Connected Call', slideName, `Video: ${subscriber.stream.hasVideo}`)
          }, 500)
        })
        document.getElementById('play-call').pause()
      })

      self.session.on('streamDestroyed', () => {
        self.closeStream()
      })
    },
    closeStream() {
      if (this.remoteVideo) {
        this._stopStreamedVideo(this.remoteVideo.stream)
      }
      if (this.localVideo) {
        this._stopStreamedVideo(this.localVideo.stream)
      }
      if (this.session) {
        this.session.off('streamCreated')
        this.session.off('streamDestroyed')
        setTimeout(() => {
          this.session.disconnect()
          this.session = null
        }, 1000)
      }
      if (!this.remoteVideo) {
        this.$http.post(config.api.stopVideoCall, {
          isPresenter: true,
          uniqueAccessCode: this.presentation.uniqueAccessCode,
        })
      }
      document.getElementById('play-call').pause()
      this.$store.state.voiceCall = {}
      const { type, slideType } = this.slideActive
      const slideName = utils.getCorrectSlideTypeName(type, slideType)
      utils.mixpanelTracking('Video Call', 'Presenter Close Call', slideName)
    },
    _stopStreamedVideo(stream) {
      const tracks = stream.getTracks()
      tracks.forEach((track) => {
        track.stop()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar {
  margin: 0 auto;
  margin-bottom: 16px;
  position: absolute;
}
.voice-call {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000bf;
  z-index: 1000;
  color: #fff;
}
.beta-label {
  position: absolute;
  top: 4px;
  right: -42px;
  background-color: #33c181;
  padding: 2px 45px;
  font-size: 12px;
  transform: rotate(45deg);
}

#local-video {
  position: fixed;
  width: 10px;
  height: 10px;
  left: -9999px;
}
#remote-video {
  width: auto;
  height: 100%;
}
#play-call {
  position: fixed;
  width: 10px;
  height: 10px;
  left: -9999px;
}
.avatar {
  z-index: 100;
  &::v-deep {
    .aha-avatar {
      width: 120px !important;
      height: 120px !important;
      margin: 0 auto;
      font-size: 36px;
      font-weight: bold;
      line-height: 120px;
      margin-bottom: 32px;
    }
  }
}
.audience-name {
  font-size: 28px;
  font-weight: bold;
  text-transform: capitalize;
}
.call-status {
  position: relative;
  top: 2px;
}
.close-call {
  width: 52px;
  height: 52px;
  background-color: #DA323C;
  font-size: 23px;
  border-radius: 50px;
  cursor: pointer;
  margin-right: 12px;
  line-height: 52px;

  i {
    transform: rotate(-135deg);
  }
}
.during-video-call {
  .avatar {
    position: absolute;
    bottom: 16px;
    width: 100%;
    display: flex;
    -moz-justify-content: center;
    justify-content: center;

    &::v-deep {
      .aha-avatar {
        display: none;
      }
    }
  }
  .call-status {
    &.time-call {
      position: absolute;
      top: 0;
      margin-left: 15px;
    }
  }
}

.during-audio-call {
  #remote-video {
    width: 1px;
    height: 1px;
    position: fixed;
    left: -9999px;
    visibility: hidden;
  }
  .call-status {
    position: unset;
    margin-left: 0;
  }
}

.full-h {
  height: 100%;
}
</style>
